var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{staticClass:"mr-4",attrs:{"color":"primary","type":"border"},on:{"click":function($event){$event.preventDefault();return _vm.backToOriginalUser.apply(null, arguments)}}},[_vm._v("\n  Voltar ao Usuário Original\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }